import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

/**
 * Generic hook factory for API queries
 * Creates a custom hook that accepts any async function
 */
export function createApiQueryHook<
  TData,
  TParams extends Record<string, unknown>,
>(
  queryFn: (params: TParams) => Promise<TData>,
  queryKeyFactory?: (params: TParams) => unknown[]
) {
  return function useCustomQuery(
    params: TParams,
    options?: Omit<
      UseQueryOptions<TData, Error, TData, unknown[]>,
      'queryKey' | 'queryFn'
    >
  ): UseQueryResult<TData, Error> {
    const queryKey = queryKeyFactory
      ? queryKeyFactory(params)
      : [queryFn.name, params];

    return useQuery({
      queryKey,
      queryFn: () => queryFn(params),
      ...options, // This properly spreads all options including enabled
    });
  };
}
